import { UUID } from "../generic/uuid";
import {
  createOrganisationDtoFromAnalyticOrganisationModel,
  OrganisationModel,
} from "./organisation";
import { SupplierDto } from "@vini-wine/core-dtos";

export interface SupplierModel extends UUID {
  // transform
  name: string;

  // available includes
  organisation?: OrganisationModel;
  supplierOrganisation?: OrganisationModel;
}

export const createSupplierDtoFromAnalyticSupplierModel = (
  supplier: SupplierModel,
): SupplierDto => {
  return {
    name: supplier.name,
    uuid: supplier.uuid,
    supplierOrganisation: supplier.supplierOrganisation
      ? createOrganisationDtoFromAnalyticOrganisationModel(
          supplier.supplierOrganisation,
        )
      : undefined,
  };
};
